module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Other#2-19ff202b9910136866a05f016719005b.svg";